import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/** Broadcasts a signal to all subscribers just before the Rx is saved, allowing components to commit any unsaved state. */
@Injectable({
	providedIn: 'root'
})
export class BeforeRxSaveService {
	readonly beforeSave$ = new Subject<void>();
}
